//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getResult, getDetail, LOAN_TYPES, formatNumber } from '../index/const'
import Tabs from './_tabs'
import { TABS, TYPES, TYPE_TX } from './conf'
import wxCharts from './canvas'
import GuideToPrepayment from './_guide_to_prepayment'
import share_mixins from '../../share_mixins'
export default {
    mixins: [share_mixins],
    data () {
        return {
            result: {
                monthly_payment: '',
                total_interest: '',
                total_payment: ''
            },
            loan: '',
            year: '',
            list: [],
            tip: '',
            tabs: TABS,
            selected_tab: TYPES.INTEREST,
            params: {}
        }
    },
    props: {
        qr_img: String,
        history_url: String,
        prepayment_calc_link: String,
        redirect_url: String,
    },
    components: {
        GuideToPrepayment,
        Tabs
    },
    mounted () {
        const { params } = this.$route.query
        if (!params) {
            wx.redirectTo({
                url: this.redirect_url
            })
        } else {
            this.params = JSON.parse(params)
            this.selected_tab = this.params.type.type || TYPES.INTEREST
            this.getData()
        }
    },
    methods: {
        changeTab(tab) {
            this.selected_tab = tab
            this.params.type.text = TYPE_TX[tab]
            this.params.type.type = tab
            this.getData()
        },
        getData () {
            const params = this.params
            const { business_loan, public_loan, type } = this.params
            this.tip = type.text === '等额本息' ? '每月还款金额不变' : '首月还款，每月递减'
            this.year = params.year
            this.loan = (params.loan_type === LOAN_TYPES.COMPOSE ? Number(business_loan) + Number(public_loan) : params.loan)
            const result = getResult(params)
            result.monthly_payment = formatNumber(result.monthly_payment)
            result.total_interest = formatNumber(Number(result.total_interest) / 10000)
            result.total_payment = formatNumber(Number(result.total_payment) / 10000)
            this.result = result
            this.getList(params)
        },
        getList (params) {
            const { business_loan, public_loan, loan, loan_type } = params
            this.is_compose = loan_type === LOAN_TYPES.COMPOSE
            const result = getDetail(params)
            this.list = result.reduce((list, item) => {
                const year_items = item.month_data_arr.map(({ data }) =>{
                    data.monthly_payment = formatNumber(data.monthly_payment)
                    data.base_payment = formatNumber(data.base_payment)
                    data.interest_payment = formatNumber(data.interest_payment)
                    data.reset_payment = this.is_compose ? formatNumber(Number(data.reset_payment.public_rest) + Number(data.reset_payment.business_rest)) : formatNumber(data.reset_payment)
                    return data
                })
                list.push(...year_items)
                return list
            }, [])
        }
    }
}
